import { useLingui } from '@lingui/react'
import { type FC } from 'react'

import Price from 'views/components/atoms/Price'

type Props = {
  currency: string
  price: number
  unitPricing: string
}

const ProductInfoPrice: FC<Props> = ({ currency, price, unitPricing }) => {
  const { i18n } = useLingui()
  return (
    <div className="u-color--grey o-ProductInfo__list-item">
      <Price currency={currency} amount={price} />
      {unitPricing &&
        ` (${unitPricing
          .replace('EUR', '€')
          .replace('st', i18n._('product.attribute.unit.pcs'))})`}
    </div>
  )
}

export default ProductInfoPrice
